import { render, staticRenderFns } from "./AddSuperAdminComponent.vue?vue&type=template&id=353124bc&"
import script from "./AddSuperAdminComponent.vue?vue&type=script&lang=js&"
export * from "./AddSuperAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports